<template>
  <div class="apiReservations">
    <Loading v-if="loading" />
    <div class="apiReservations__search">
      <div class="input-block">
        <img
          class="dropdown-img"
          src="@/assets/icons/Search.svg"
          alt="Search"
        />
        <input
          v-model="search"
          class="input-search"
          :placeholder="$t('search')"
          @input="changeInput"
        />
        <Dropdown
          className="dropdown-search"
          :selectedOption="getSearchBy.selectedOption"
          :options="getSearchBy.options"
          @selectOption="changeSearchBy"
        />
      </div>
    </div>
    <div class="apiReservations__table">
      <Table
        v-if="data.length && !loading"
        :data="data"
        :columns="columns"
        :idActiveDelivery="idActiveDelivery"
        :changeSort="changeSort"
        selectedField="deliveryId"
        @assignDeliveryTable="assignDeliveryTable"
        @quickReservation="quickReservation"
        @deleteReservationTable="deleteReservationTable"
        @pickedUpReservation="pickedUpReservation"
        @goToItem="infoReservation"
        @sortReservedTime="sortReservedTime"
      />
    </div>
    <div v-if="!data.length" class="apiReservations__no-table">
      <p>{{ $t('noReservations') }}</p>
    </div>
  </div>
  <AssignDelivery
    :showModalAssign="showModalAssign"
    :activeReservations="activeReservations"
    @closeModal="showModalAssign = false"
    @assignDeliveryRequest="assignDeliveryRequest"
  />
  <QuickReservation
    v-if="showModalQuickReservation"
    :showModalQuickReservation="showModalQuickReservation"
    :activeReservations="activeReservations"
    @closeModal="showModalQuickReservation = false"
  />
  <PickedUpReservation
    :showModalPickedUpReservation="showModalPickedUpReservation"
    :idDelivery="idDelivery"
    :activeReservations="activeReservations"
    @show="show"
    @closeModal="showModalPickedUpReservation = false"
    @pickedUpReservationRequest="pickedUpReservationRequest"
  />
  <DeleteReservation
    :showModalDestroy="showModalDestroy"
    :idDelivery="idDelivery"
    @closeModal="showModalDestroy = false"
    @destroyReservationRequest="destroyReservationRequest"
  />
  <InfoReservation
    :showModalInfoReservation="showModalInfoReservation"
    @closeModal="showModalInfoReservation = false"
    :activeReservations="activeReservations"
    :showDecodedSsn="showDecodedSsn"
    @getDecodedSsn="getDecodedSsn"
  />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import AssignDelivery from '@/duplicatePages/AssignDelivery/AssignDelivery.vue';
import QuickReservation from './QuickReservation/QuickReservation.vue';
import PickedUpReservation from '@/duplicatePages/PickedUpReservation/PickedUpReservation.vue';
import DeleteReservation from '../Reservations/DeleteReservation/DeleteReservation.vue';
import InfoReservation from '@/duplicatePages/InfoReservation/InfoReservation.vue';

import Loading from '@/views/Loading.vue';

import { columns, searchActions } from './configs';
import {
  APIDataReservations,
  DataReservations,
  PickupBox,
  Reservation,
  SSNData
} from '@/store/modules/pharmacy/types';
import { InputFileEvent, Option } from '@/types';

@Options({
  name: 'APIReservations',
  emits: [
    'assignDeliveryRequest',
    'quickReservationRequest',
    'deleteReservationRequest',
    'destroyReservationRequest',
    'pickedUpReservationRequest',
    'getDecodedSsn',
    'sortReservedTime'
  ],
  components: {
    AssignDelivery,
    QuickReservation,
    Loading,
    PickedUpReservation,
    DeleteReservation,
    InfoReservation
  },
  data() {
    return {
      data: [],
      dataSearchBy: [],
      columns: columns(this.$t),
      reservations: [],
      activeReservations: null,
      activePickupBox: null,
      idDelivery: '',
      idActiveDelivery: '',
      idPickupBox: '',
      showDecodedSsn: '',
      search: '',
      getSearchBy: {
        selectedOption: {
          value: 'deliveryId',
          label: this.$t('kolliID')
        },
        options: searchActions(this.$t)
      },
      loading: false,
      stop: false,
      changeSort: false,
      showModalAssign: false,
      showModalDestroy: false,
      showModalInfoReservation: false,
      showModalQuickReservation: false,
      showModalPickedUpReservation: false
    };
  },
  async created() {
    if (this.pharmacy && !this.stop) {
      this.show();
    }
  },
  computed: {
    ...mapState('pharmacy', [
      'pharmacy',
      'pickupBoxes',
      'decodedSsn',
      'deliveryFindBySSN'
    ])
  },
  methods: {
    ...mapActions('pharmacy', [
      'assignDelivery',
      'getPharmacy',
      'getPickupBoxesByPharmacy',
      'updateDescription',
      'updatePharmacyReservation',
      'destroyReservation',
      'getDeliveryShowDecodedSsn',
      'getDeliveryFindBySSN'
    ]),
    /* eslint-disable */
    async show() {
      this.stop = true;
      const { id } = this.$route.params;

      this.loading = true;

      await this.getPickupBoxesByPharmacy(id);
      await this.getPharmacy(id);

      this.loading = false;
    },
    async loadAPIReservation() {
      this.loading = true;

      if (this.pharmacy) {
        this.reservations = this.pharmacy?.reservations || [];
        this.data = [...this.reservations]?.filter(
          (reservation: DataReservations) => reservation.unassigned === true
        );
      }

      this.data.sort((a: DataReservations, b: DataReservations) => {
        return b.reservedTime - a.reservedTime;
      });

      this.dataSearchBy = this.data;

      this.loading = false;
    },
    assignDeliveryTable(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      this.sortReservedTime();
      this.showModalAssign = true;
    },
    changeInput(e: InputFileEvent) {
      const { value } = e.target;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (value === '') {
          this.show();
        } else if (this.getSearchBy.selectedOption.value === 'phoneNumber') {
          this.data = [...this.dataSearchBy].filter((item: DataReservations) =>
            item.phoneNumber.toLowerCase().includes(value?.toLowerCase())
          );
        } else if (this.getSearchBy.selectedOption.value === 'deliveryId') {
          this.data = [...this.dataSearchBy].filter((item: DataReservations) =>
            item.deliveryId.toLowerCase().includes(value?.toLowerCase())
          );
        } else if (this.getSearchBy.selectedOption.value === 'ssn') {
          this.changeSearchBy(this.getSearchBy.selectedOption);
        }
      }, 600);
    },
    getSSN() {
      if (this.getSearchBy.selectedOption.value === 'ssn') {
        if (this.search === '') {
          this.show();
        } else {
          const deliveryFindBySSNData =
            this.deliveryFindBySSN[this.pharmacy.id] || [];

          this.data = deliveryFindBySSNData;
          this.dataSearchBy = deliveryFindBySSNData;
        }
      }
    },
    async changeSearchBy(option: Option) {
      this.getSearchBy.selectedOption = option;

      if (
        this.getSearchBy.selectedOption?.value === 'ssn' &&
        this.search !== ''
      ) {
        this.loading = true;
        await this.getDeliveryFindBySSN({
          ssn: this.search,
          unassigned: true
        });
        this.getSSN();

        this.loading = false;
      } else {
        this.data = [...this.dataSearchBy].filter(
          (item: DataReservations[] | any) =>
            item[this.getSearchBy.selectedOption.value]
              ?.toLowerCase()
              .includes(this.search.toLowerCase())
        );
      }
    },
    async assignDeliveryRequest(
      deliveryId: string,
      description: string,
      shelf: string
    ) {
      this.loading = true;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      const { id } = this.$route.params;

      if (shelf) {
        if (description) {
          const payloadDescription = {
            descriptionText: description,
            pharmacyId: id,
            reservedTime: this.activeReservations.reservedTime
          };

          await this.updateDescription({
            data: payloadDescription,
            deliveryId
          });
        }

        const payloadShelf = {
          assignToBox: false,
          boxInfo: undefined,
          shelf
        };

        await this.assignDelivery({
          data: payloadShelf,
          pharmacyId: id,
          deliveryId: deliveryId
        });

        await this.getPharmacy(id);

        this.showModalAssign = false;
        this.loading = false;

        this.loadAPIReservation();
      }

      this.loading = false;
    },
    quickReservation(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      this.showModalQuickReservation = true;
    },
    pickedUpReservation(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: APIDataReservations) => i.deliveryId === deliveryId
      );

      this.showModalPickedUpReservation = true;
    },
    async pickedUpReservationRequest(deliveryId: string) {
      this.loading = true;
      const { id } = this.$route.params;

      const payload = {
        deliveryStatus: 'pickup'
      };

      await this.updatePharmacyReservation({
        data: payload,
        pharmacyId: id,
        deliveryId: deliveryId
      });

      this.loading = false;
      this.showModalPickedUpReservation = false;

      this.getPharmacy(id);
      this.loadAPIReservation();
    },
    deleteReservationTable(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: APIDataReservations) => i.deliveryId === deliveryId
      );

      this.showModalDestroy = true;
    },
    async destroyReservationRequest(deliveryId: string) {
      const { id } = this.$route.params;

      const payload = {
        pharmacyId: id,
        deliveryId
      };

      await this.destroyReservation(payload);

      this.loading = false;
      this.showModalDestroy = false;

      this.getPharmacy(id);
      this.loadAPIReservation();
    },
    infoReservation(deliveryId: string) {
      this.activeReservations = this.data.find(
        (i: APIDataReservations) => i.deliveryId === deliveryId
      );

      this.showModalInfoReservation = true;
    },
    async getDecodedSsn(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: APIDataReservations) => i.deliveryId === deliveryId
      );

      this.activePickupBox = this.pickupBoxes.find((pickupBox: PickupBox) =>
        pickupBox.reservations
          .map((i: Reservation) => i.deliveryId)
          .includes(this.activeReservations.deliveryId)
      );

      this.loading = true;

      this.idPickupBox = this.activePickupBox?.id;
      const { id } = this.$route.params;

      const params: SSNData = {
        deliveryId: this.activeReservations.deliveryId,
        reservedTime: this.activeReservations.reservedTime
      };

      if (this.idPickupBox) {
        params.pickupboxId = this.idPickupBox;
      } else {
        params.pharmacyId = id;
      }

      await this.getDeliveryShowDecodedSsn(params);

      this.showDecodedSsn = this.decodedSsn.ssn;
      this.loading = false;
    },
    sortReservedTime() {
      this.changeSort = !this.changeSort;
      if (this.changeSort) {
        this.data.sort((a: APIDataReservations, b: APIDataReservations) => {
          return a.reservedTime - b.reservedTime;
        });
      } else {
        this.data.sort((a: APIDataReservations, b: APIDataReservations) => {
          return b.reservedTime - a.reservedTime;
        });
      }
    }
  },
  watch: {
    async pharmacy() {
      if (this.pharmacy) {
        this.loadAPIReservation();
      }
    },
    showModalInfoReservation() {
      this.showDecodedSsn = '';
    }
  }
})
export default class APIReservations extends Vue {}
</script>

<style lang="scss">
.apiReservations {
  padding: 24px;
  .apiReservations__search {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 23px;
    .apiReservations__search-button {
      width: 190px;
    }
    .input-block {
      display: flex;
      position: relative;
      margin-left: 10px;
      .input-search {
        width: 245px;
        height: 38px;
        padding-left: 36px;
        font-size: $fourteenSize;
        border: 1px solid $border;
        border-right: 0;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        outline: none;
      }
      .dropdown-img {
        position: absolute;
        top: 14px;
        left: 17px;
      }
      .dropdown {
        max-width: 175px;
        .dropdown-search {
          height: 40px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }
  }
}
</style>
